import { useString as s } from "../../../../../components/StringProvider";
import { ReactComponent as Icon } from "../../../../../assets/editor/type-strikethrough.svg";
import ToolbarButton from "./ToolbarButton";

const StrikethroughButton = ({ onClick, active }) => {
  return (
    <ToolbarButton
      active={active}
      onClick={onClick}
      label={s("editor.buttons.strikethrough.label", "Format Strikethrough")}
    >
      <Icon />
    </ToolbarButton>
  );
};

export default StrikethroughButton;
